export default __webpack_public_path__ + "static/media/mortgageIcon.4ac48ffb.svg";